const itemTypeList = [
  '전체', '일반액상', '모드액상', '일반코일', '모드코일', '하카', '팟', '공팟',
  '일반키트', '모드키트', '일반단품', '모드단품', '일반무화기', '모드무화기',
  '기타', '일회용', '충전기', '리빌드무화기', '궐련형'
  ];

export default itemTypeList;